import { Link } from 'lib/ui/link';
import { URLBuilder } from 'url-builder/url-builder';

export class CountyLink extends Link {
    constructor(options) {
        const { county, urlBuilder = URLBuilder.defaultURLBuilder } = options;

        const mainURL = urlBuilder.getUrl({ url: 'bazaar' });

        super({
            label: county.name,
            href: () => `${mainURL}?county=${county.name}`,
        });

        this.county = county;
    }
}
